<template>
  <div id="content" class="startup_page">

    <DetailAssessment @close="detailAssessment=false" :startup="detailsForCandidate" :dialogVisible="detailAssessment">  </DetailAssessment>


      <div class="content_div stats">
        <div class="row mt50" >
          <div class="titre">

              <h1 class="text-center" v-if="titre.toUpperCase() == 'LONG LIST'">Innovators in Long List</h1>
              <h1 class="text-center" v-else-if="titre.toUpperCase() == 'SELECTED FOR ASSESSMENT'">Innovators Selected for assessment</h1>
              <h1 class="text-center" v-else-if="titre.toUpperCase() == 'MEDIUM INTEREST'">Innovators with Medium interest</h1>
              <h1 class="text-center" v-else-if="titre.toUpperCase() == 'HIGH INTEREST'">Innovators with high interest</h1>
              <h1 class="text-center"  v-else>{{titre}}</h1>
          </div>

            <div class="col-12 col-lg-6 col-xl-4 candidate" v-for="(candidate, c) in startups" :key="c">


                    <div class="candidate_card" >
                      <div class="candidate_card_head">
                        <span class="name">{{candidate.name}}</span>
                        <div class="goRight">
                            <img :src="require('@/assets/inAnAssess.svg')" @click="showCandidateAssessment(candidate)" alt="" v-if="candidate.assessments.length > 0">

                        </div>

                      </div>
                      <div class="candidate_info_content">
                        <StartupCardInner v-if="candidate.company_type?.value?.toUpperCase() == 'STARTUP'" :candidate="candidate"/>
                        <NonStartupCardInner v-else :candidate="candidate"/>

                      </div>
                        <div class="website" v-if="candidate.website">
                                       <a :href="candidate.website" target="_blank">{{ getBaseUrl(candidate.website) }}</a>
                           <!-- <a :href="candidate.website" target="_blank">{{candidate.website.replace(/^https?:\/\//, '').replace(/\/$/, '')}}</a> -->
                        </div>
                      <div class="footer">


                        <router-link :to="'/startup/'+candidate._id.$oid"  v-if="candidate._id" class="detail">
                        Details
                        </router-link>
                      </div>


                          </div>
            </div>
        </div>


      </div>
  </div>
</template>
<script>
import api from '../tools/api';
// import { debounce } from 'lodash';
//
//  import { toast } from 'vue-sonner'
import StartupCardInner from '@/components/StartupCardInner.vue'
import NonStartupCardInner from '@/components/NonStartupCardInner.vue'



  import DetailAssessment from '@/components/DetailAssessment.vue'
export default {
  components: {
    StartupCardInner,
    NonStartupCardInner,
DetailAssessment
  },
  name: 'StartupsStatsListSpace',
  data() {
    return {
      pageInfo: {
        mainTitle : "My Dashboard ",
        subTitle : "Review your current funnel ",
      },
      startups : [],
      titre : "",
      detailAssessment : false,
  detailsForCandidate:null,
    }
  },
  methods:{
    showCandidateAssessment(c){
      this.detailsForCandidate = c;
      this.detailAssessment = true;
    },
    getBaseUrl(url){
      var formated = url.replace(/^https?:\/\//, '').replace(/\/$/, '');
      try{
        var r= new URL(url).origin;
        r = r.replace(/^https?:\/\//, '').replace(/\/$/, '');
        return r;
      }catch{
        return formated;
      }
    },
  },
  mounted(){
     this.$store.commit('UPDATE_PAGE_INFO',this.pageInfo)

     console.log(this.$route.params.filterstoapply);
     const myParams = JSON.parse(this.$route.params.filterstoapply);
     console.log(myParams); // Output: { key1: 'value1', key2: 'value2' }

     this.titre  = myParams.titre_page;
     api.post(process.env.VUE_APP_API_URL+"/restrict/v2/stats_startups_list_from_funnel",
         {
             filtres: JSON.parse(this.$route.params.filterstoapply)
         },
         {
           headers: {
               'Content-Type': 'application/json',
         }
       }).then( (r) => {
       console.log(r.data);
       this.startups = r.data;
     }).catch( (e) => {
       console.log(e);
     });

  },


}
</script>
<style scoped>
.goRight{
  margin-left:auto;
  display:flex;
  flex-wrap:wrap;
  gap:20px;
}
.candidate_card{
  border: 2px solid #DDDDDD;
border-radius: 15px;
z-index: 5;
height:100%;
display: flex;
flex-direction: column;
}
.candidate_card .candidate_image{
  width:100%;
  height:200px;
  object-fit: cover;
  z-index: 1;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
}


.candidate_card .candidate_links{
  display:flex;
  flex-direction: row;
  flex-wrap: wrap;
  padding: 20px 5px;

  margin: 0;
}
.candidate_card .candidate_info_content .candidate_name{
  font-size:18px;
  line-height:21px;
letter-spacing: 0px;
color: #3783C5;
text-transform: uppercase;
display:block;
font-weight: 500;
}

.candidate_card .candidate_info_content .candidate_desc{
  font-size:16px;
  line-height:22px;
  margin-top:10px;
  display:block;
  margin-bottom:10px;
}
.candidate_card .candidate_links .details{
  font-size:12px;
  line-height: 15px;
  border-right: 1px solid #DDD;
  display:flex;
  align-items: center;
  text-transform: uppercase;
  color: #3783C5;
  flex: 0.5;

}
.candidate_card .candidate_links .details a{
    text-decoration: none;
}
.candidate_card .candidate_links .details img{
  margin-right:5px;
}
.candidate_card .candidate_links .selectIt{
  font-size:12px;
  line-height: 15px;
  letter-spacing: 0px;
  color: #3783C5;
  text-transform: uppercase;
  flex:0.5;
  align-items: flex-end;

}
.candidate_card .candidate_links .selectIt_fw{
  flex:1;
  align-items: flex-start;
}
.candidate_card .candidate_links .selectIt_fw label{
display:flex;
align-items: center;
gap: 5px;
justify-content: start;
}
.candidate_card .candidate_links .selectIt label{
display:flex;
align-items: center;
gap: 5px;
justify-content: end;
}
.candidate_card .candidate_links .selectIt input{
  width:24px;
  height:24px;
}
.candidate_card .candidate_links .details.noBorder{
  border-right: none;

}


@media screen and (max-width: 690px){
  .candidate_card .candidate_links{
    flex-direction: column;
    flex-wrap: wrap;
    gap: 20px
  }
  .candidate_pool{
      padding: 20px;
    }
    .candidate_card .candidate_links .details{
      border-right: none;
      border-bottom:1px solid #DDD;
      padding-bottom: 20px;
    }
    .candidate_card .candidate_links .selectIt label{
    display:flex;
    align-items: center;
    gap: 5px;
    justify-content: start;
    flex-direction: row-reverse;
    }
    .filtre_list {
  display: grid;
  grid-template-columns: auto auto auto;
  grid-template-columns: 1fr;
  grid-auto-rows: 100%;
  gap: 10px;
}
}

.candidate_card_head{
  background: transparent linear-gradient(270deg, #3783C5 0%, #1368B2 100%) 0% 0% no-repeat padding-box;

  padding: 10px;
  color: #FFF;
  text-transform: uppercase;
  font-weight: bold;
  border-radius: 10px 10px 0px 0px;
  display:flex;
  align-content: center;
    align-items: center;
gap:10px;
min-height: 60px;
}
.candidate_card .candidate_info_content{
  padding:20px;
  flex-grow: 1;
}
.startup_page{
  padding-top:50px;
  padding-bottom: 50px;
  padding: 50px;
}
.content_div{
  /* margin-top:50px;
  margin-bottom: 50px; */
  padding: 50px;
  background: #FFFFFF 0% 0% no-repeat padding-box;
box-shadow: 0px 3px 6px #00000029;
border-radius: 8px;
}
.chart-container {
  position: relative;
}

.next_step_btn,
.next_step_btn:hover{
  background: #3783C5 0% 0% no-repeat padding-box !important;
  box-shadow: 0px 3px 6px #00000029 !important;
  border: 1px solid #3783C5 !important;
  border-radius: 50px;
  opacity: 1;
  padding: 14px 37px;
  color:#FFF;
  margin:5px;
}

.prev_step_btn,
.prev_step_btn:hover{
  border: 1px solid #3783C5;
  border-radius: 50px;
  opacity: 1;
  padding: 14px 37px;
  color:#3783C5;
    margin:5px;
    text-decoration: none;
}

.canvasjs-chart-credit{
  display:none;
}
.candidate{
  margin-top:20px;
  margin-bottom: 20px;
}
/*
.candidate{
  margin-top:20px;
  margin-bottom: 20px;
}
.candidate_card{
  border: 1px solid #DDDDDD;
border-radius: 10px;
z-index: 5;
height:100%;
display: flex;
flex-direction: column;
}
.candidate_card .candidate_image{
  width:100%;
  height:200px;
  object-fit: cover;
  z-index: 1;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
}
.candidate_card .candidate_info_content{
  padding:20px;
  border-bottom: 1px solid #DDDDDD;
}

.candidate_card .candidate_links{
  padding:20px;
  display:flex;
  flex-direction: row;
  flex-wrap: wrap;
}
.candidate_card .candidate_info_content .candidate_name{
  font-size:18px;
  line-height:21px;
letter-spacing: 0px;
color: #3783C5;
text-transform: uppercase;
display:block;
font-weight: 500;
}

.candidate_card .candidate_info_content .candidate_desc{
  font-size:16px;
  line-height:22px;
  margin-top:10px;
  display:block;
  margin-bottom:10px;
}
.candidate_card .candidate_links .details{
  font-size:12px;
  line-height: 15px;
  border-right: 1px solid #DDD;
  display:flex;
  align-items: center;
  text-transform: uppercase;
  color: #3783C5;
  flex: 0.5;

}
.candidate_card .candidate_links .details a{
    text-decoration: none;
}
.candidate_card .candidate_links .details img{
  margin-right:5px;
}
.candidate_card .candidate_links .selectIt{
  font-size:12px;
  line-height: 15px;
  letter-spacing: 0px;
  color: #3783C5;
  text-transform: uppercase;
  flex:1;
  align-items: flex-end;

}
.candidate_card .candidate_links .selectIt label{
display:flex;
align-items: center;
gap: 5px;
justify-content: end;
}
.candidate_card .candidate_links .selectIt input{
  width:24px;
  height:24px;
}
.candidate_card .candidate_links .details.noBorder{
  border-right: none;

}
@media screen and (max-width: 690px){
  .candidate_card .candidate_links{
    flex-direction: column;
    flex-wrap: wrap;
    gap: 20px
  }
  .candidate_pool{
      padding: 20px;
    }
    .candidate_card .candidate_links .details{
      border-right: none;
      border-bottom:1px solid #DDD;
      padding-bottom: 20px;
    }
} */

.website{
  color:#4c81c0 !important;
  font-size:14px;
  text-align:center;
  margin-bottom:20px;
  font-weight:700;
}
.titre{
  margin-bottom: 20px;
}
.titre h1{
  color: #B38D2F;
  text-transform: uppercase;
  display: block;
  font-weight: 500;
  letter-spacing: 0px;
  text-transform: uppercase;
  font-size: 28px;
  line-height: 34px;

}


.footer{
padding-left: 20px;
  padding-right: 20px;
    padding-bottom: 10px;
  font-weight:bold;
  text-transform: uppercase;
  color:#B38D2F !important;
  font-size:14px;
  display:flex;
  flex-wrap:wrap;
  gap:10px;
}

.footer a{
  margin-left: auto;
}
.footer *{
  color:#4c81c0 !important;
  font-size:14px;
}

.website a{
  color:#4c81c0 !important;
}
.detail{
  background: #F1F6FB;
padding: 10px 20px;
border-radius: 50px;
text-align: center;
}
</style>
